import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AddCustomerDialogComponent } from './add-customer-dialog/add-customer-dialog.component';
import { AlertsModule } from 'src/shared/alerts/alerts.module';
import { BillingDetailsModule } from 'src/shared/billing-details/billing-details.module';
import { CommonModule } from '@angular/common';
import { CustomerListComponent } from './customer-list/customer-list.component';
import { DivisionListComponent } from './division-list/division-list.component';
import { AuditTrailListComponent } from './audit-trail-list/audit-trail-list.component';
import { FilterFnPipe } from '../../shared/pipes/filter-fn.pipe';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormModelsModule } from 'src/shared/form-models/form-models.module';
import { JobAssignmentsListComponent } from './job-assignments-list/job-assignments-list.component';
import { JobListComponent } from './job-list/job-list.component';
import { MaterialModule } from 'src/shared/material/material.module';
import { NgModule } from '@angular/core';
import { PhonePipe } from '../../shared/pipes/phone.pipe';
import { RailroadListComponent } from './railroad-list/railroad-list.component';
import { RouterModule } from '@angular/router';
import { RwicListComponent } from './rwic-list/rwic-list.component';
import { SharedGlobalModule } from '../../shared/shared-global.module';
import { SubdivisionListComponent } from './division-list/subdivision-list/subdivision-list.component';
import { AuditTrailDialogComponent } from './audit-trail-dialog/audit-trail-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        FormsModule,
        FlexLayoutModule,
        ReactiveFormsModule,
        RouterModule,
        SharedGlobalModule,
        BillingDetailsModule,
        FormModelsModule,
        AlertsModule,
    ],
    declarations: [
        AddCustomerDialogComponent,
        JobListComponent,
        RwicListComponent,
        DivisionListComponent,
        SubdivisionListComponent,
        CustomerListComponent,
        RailroadListComponent,
        JobAssignmentsListComponent,
        AuditTrailListComponent,
		AuditTrailDialogComponent
    ],
    exports: [
        FilterFnPipe,
        PhonePipe,
        SharedGlobalModule,
        JobListComponent,
        RwicListComponent,
        DivisionListComponent,
        CustomerListComponent,
        RailroadListComponent,
        JobAssignmentsListComponent,
        AuditTrailListComponent,
		AuditTrailDialogComponent
    ]
})
export class SharedModule { }
